import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { PhotoDialogComponent } from '../photo-dialog/photo-dialog.component';
import { ImageManagerService } from '@app/kip/services/image-manager.service';
import { vwTaskListItem } from '@app/kip/viewdto/vwCleaningState/vwTaskListItem';
import { vwDailyTask } from '@app/kip/viewdto/vwdailytask/vwDailTask';

@Component({
  selector: 'reject-task-dialog',
  templateUrl: './reject-task-dialog.component.html',
  styleUrls: ['./reject-task-dialog.component.scss']
})



export class RejectTaskDialogComponent {
  editorForm: FormGroup;
  _data: vwTaskListItem ;
  photoBase64 : string="";
  constructor( public dialogRef: MatDialogRef<RejectTaskDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: vwTaskListItem,
              private photoDialog : MatDialog, 
              private translate: TranslateService,
              private imageManagerService: ImageManagerService,
              private fb: FormBuilder) {
    this._data = data;
    this.editorForm = this.fb.group({
      Comment:  new FormControl(data.Comment) 
    });
  }


  openPhotoDialog(item: vwTaskListItem) {

     const dialogRef = this.photoDialog.open(PhotoDialogComponent,
      {
        disableClose: true,
        hasBackdrop: true,
        minWidth: '100vw',
        minHeight: '100vh',
        data: item
      })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
       this.photoBase64 = result;
      }
    })}



  submit() {
    var res : RejectTaskDto = new RejectTaskDto();
    res.DailyTask = this._data;
    res.DailyTask.Comment = this.editorForm.controls["Comment"].value;
    res.PhotoBase64 = this.photoBase64;
    this.dialogRef.close(res);
  }
  
  cancel() {
    this.dialogRef.close(undefined)
  }
}


export class RejectTaskDto   {
  public PhotoBase64 : string;
  public DailyTask: vwTaskListItem;
 
}